import {AjaxClient} from 'ajax-client';
const ini_parser = require('ini');

window.addEventListener('load', () => {
  const client = new AjaxClient;
  client.ajax({
    type: 'get',
    url: '/netsoudan/advertisement/ad.ini',
    contentType: 'text/plain',
    dataType: 'text',
    timeoutMills: 1000,
    success: (response, _xhr) => {
      const config = ini_parser.parse(response)?.advertisement;
      const active = Number(config?.active || '0');
      const url = config?.url || null;
      const alt = config?.alt || '';
      const img_pc = config?.img_pc;
      const img_sp = config?.img_sp || img_pc;
      if (active && url && img_pc) {
        const img = (window.innerWidth < 700) ? img_sp : img_pc;
        document.getElementById('adv-href').setAttribute('href', url);
        document.getElementById('adv-img').setAttribute('alt', alt);
        document.getElementById('adv-img').setAttribute('src', `advertisement/${img}`);

        const elemadv = document.getElementById('advertisement');
        const elemkyousan = document.createElement('p');
        elemkyousan.prepend(document.createTextNode('【協賛】'));
        elemadv.prepend(elemkyousan);

        elemadv.style.display = 'inline-block';
      }
    },
    error: (_data, _response, _cause, _err) => {
      // nothing to do
    }
  });
});
